import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Cabserviceinelectroniccitybanglore() {



  const cardData =
  {
    keyword: ' Cab Service in Electronic City Bangalore',
    heading: 'Pune Corporate Cars India Private Limited: Cab Service in Electronic City Bangalore',
    headingDescription: 'Pune Corporate Cars India Private Limited provides professional and reliable Cab Service in Electronic City Bangalore, catering to the transportation needs of IT companies, corporate offices, and business parks in the area. Our fleet of executive sedans, SUVs, and premium vehicles ensures safe, comfortable, and timely travel for employees, clients, and senior executives. Whether it is daily office commute, airport transfers, inter-office travel, business meetings, or VIP transportation, we deliver seamless and hassle-free mobility solutions. With trained chauffeurs, flexible rental plans, and well-maintained vehicles, Pune Corporate Cars India Private Limited ensures a premium and dependable corporate travel experience for businesses operating in and around Electronic City Bangalore.',

    top: 'Top Places to Visit in Bangalore with Pune Corporate Car',

"topPlaces": [
  {
    "title": "Bangalore Palace",
    "description": "Bangalore Palace is an architectural marvel inspired by England’s Windsor Castle, built in the 19th century. The palace features Tudor-style architecture, fortified towers, elegant woodwork, and sprawling gardens. Visitors can explore the royal interiors, vintage furniture, and photo galleries. The palace also hosts cultural events, music concerts, and exhibitions, offering a blend of history, art, and heritage in the heart of Bangalore."
  },
  {
    "title": "Lalbagh Botanical Garden",
    "description": "Lalbagh Botanical Garden is a 240-acre green oasis in Bangalore, famous for its diverse collection of flora, centuries-old trees, glasshouse, and flower shows. The garden offers walking paths, serene lakes, and picturesque landscapes, making it ideal for nature lovers, photographers, and families. Seasonal flower exhibitions attract visitors from across the city and beyond."
  },
  {
    "title": "Cubbon Park",
    "description": "Cubbon Park is a lush, sprawling park in central Bangalore, covering over 300 acres. With walking trails, jogging paths, playgrounds, and abundant greenery, it serves as a popular recreational spot for locals and tourists alike. The park also houses several government buildings and statues, creating a perfect blend of nature, culture, and history in the city."
  },
  {
    "title": "Vidhana Soudha",
    "description": "Vidhana Soudha is an iconic government building and a symbol of Bangalore’s political and architectural heritage. Built in a Neo-Dravidian style, it features grand pillars, domes, and intricately carved stonework. Visitors admire the building’s majestic facade, especially during evening lightings. Though entry is restricted, the surrounding area and viewpoints provide excellent photo opportunities."
  },
  {
    "title": "ISKCON Temple Bangalore",
    "description": "The ISKCON Temple is a major spiritual and cultural center in Bangalore, dedicated to Lord Krishna. The temple complex features traditional architecture, colorful murals, a large prayer hall, and beautiful gardens. Visitors can attend devotional ceremonies, participate in cultural programs, and enjoy vegetarian meals at the temple’s food court. It is a serene escape for meditation and spiritual learning in the bustling city."
  },
  {
    "title": "Commercial Street",
    "description": "Commercial Street is Bangalore’s bustling shopping hub, offering a variety of clothing, footwear, jewelry, accessories, and street food. It is popular among locals and tourists looking for shopping, bargain hunting, and exploring vibrant street markets. The lively atmosphere, diverse shops, and colorful storefronts make it a must-visit for retail enthusiasts."
  },
  {
    "title": "Bannerghatta National Park",
    "description": "Bannerghatta National Park is a major wildlife destination near Bangalore, featuring a zoo, butterfly park, safari rides, and trekking trails. Visitors can observe lions, tigers, elephants, and a variety of other animals in naturalistic settings. The park is perfect for families, wildlife enthusiasts, and students seeking educational and recreational experiences close to the city."
  },
  {
    "title": "Ulsoor Lake",
    "description": "Ulsoor Lake is a picturesque water body located in central Bangalore, ideal for boating, photography, and evening strolls. The lake is surrounded by lush greenery, walking paths, and small islands. It is a peaceful spot for relaxation, picnics, and spending time with family or friends, offering a serene escape within the urban landscape."
  },
  {
    "title": "Nandi Hills",
    "description": "Located on the outskirts of Bangalore, Nandi Hills is a scenic hill station known for its sunrise views, trekking trails, and historical sites like Tipu Sultan’s Summer Palace. The hill offers a refreshing escape from the city heat, with cool breezes, lush landscapes, and panoramic vistas. It is a favorite destination for nature lovers, photographers, and adventure seekers."
  },
  {
    "title": "Wonderla Amusement Park",
    "description": "Wonderla is one of India’s top amusement parks, located near Bangalore, offering thrilling rides, water slides, and family entertainment zones. The park is ideal for a fun-filled day with family and friends, featuring safe rides, adventure zones, and well-maintained facilities. Seasonal events and themed attractions make it a popular destination for locals and tourists seeking excitement and leisure."
  }
],


"services": [
{
"name": "E City Employee Transportation",
"description": "E City Employee Transportation provides large-scale, technology-enabled mobility solutions tailored for IT parks, corporate campuses, and industrial units in Electronic City. The service includes real-time fleet tracking, automated roster management, multi-shift employee routing, and strict safety protocols. With expert chauffeurs, modern vehicles, and 24/7 operational support, it ensures seamless, punctual, and safe employee commute across Phase 1 and Phase 2 of Electronic City."
},
{
"name": "Electronic City IT Park Cab",
"description": "Electronic City IT Park Cab delivers dedicated cab transportation designed for software companies, tech parks, and business centers within Electronic City. The service offers optimized travel routes, GPS-enabled safety monitoring, last-mile connectivity, and flexible booking models. It ensures reliable corporate travel for employees, executives, and visiting clients across all major IT hubs."
},
{
"name": "Staff Shuttle Electronic City",
"description": "Staff Shuttle Electronic City offers high-capacity shuttle vans and minibuses for large teams, ensuring timely pick-up and drop services across various routes. It supports multi-shift operations, centralized scheduling, employee attendance integration, and efficient routing designed for IT companies and manufacturing industries located in Electronic City."
},
{
"name": "Company Cab Electronic City",
"description": "Company Cab Electronic City provides end-to-end corporate cab services designed for employee commute, manager travel, and client visits. The fleet includes sedans, SUVs, and MUVs driven by verified chauffeurs, supported by 24/7 dispatching, safety monitoring, and responsive service for companies operating in Electronic City."
},
{
"name": "Employee Pickup Drop E City",
"description": "Employee Pickup Drop E City ensures structured and punctual employee transportation with pre-planned routes, shift-based scheduling, real-time trip monitoring, and trained professional drivers. The service is ideal for IT parks, BPOs, manufacturing units, and corporate offices in and around Electronic City."
},
{
"name": "Corporate Fleet Electronic City",
"description": "Corporate Fleet Electronic City provides companies with a fully managed fleet of sedans, SUVs, and employee commute vehicles. The service includes driver supervision, fleet maintenance, compliance management, and scalability for growing workforce needs. It ensures smooth operations for businesses in Electronic City’s corporate and tech corridors."
},
{
"name": "Business Cab Electronic City",
"description": "Business Cab Electronic City delivers premium corporate travel for executives, managers, and business visitors. The service includes professional chauffeurs, comfortable vehicles, priority dispatching, and customizable routes, offering reliable travel for meetings, conferences, airport transfers, and inter-office transit across Bangalore."
},
{
"name": "Monthly Corporate Cab Electronic City",
"description": "Monthly Corporate Cab Electronic City offers fixed, long-term cab rental packages for companies that require continuous employee transport or dedicated vehicles for daily corporate operations. The service covers fuel, driver management, vehicle upkeep, and GPS tracking, ensuring hassle-free mobility throughout the month."
},
{
"name": "Affordable Cab Electronic City",
"description": "Affordable Cab Electronic City provides budget-friendly transportation solutions without compromising on safety, reliability, or comfort. Designed for startups, mid-sized companies, and industrial organizations, the service ensures cost-efficient daily commute, corporate travel, and shuttle mobility within Electronic City and nearby regions."
},
{
"name": "Outstation Cab Electronic City",
"description": "Outstation Cab Electronic City offers long-distance travel solutions for corporate groups, executives, and teams traveling to other cities for business meetings, plant visits, and client engagements. The service features trained drivers, comfortable vehicles, safety monitoring, and reliable interstate connectivity."
},
{
"name": "Sedan Cab Electronic City",
"description": "Sedan Cab Electronic City provides comfortable and executive-grade sedan vehicles ideal for corporate clients, daily office commute, senior management travel, and airport trips. Each vehicle is equipped with modern amenities, GPS tracking, and is driven by well-trained, professional chauffeurs."
},
{
"name": "SUV Cab Electronic City",
"description": "SUV Cab Electronic City offers spacious and powerful SUVs suitable for group travel, senior executive movement, long-distance corporate trips, and high-comfort commute requirements. With trained drivers and safety systems, it ensures a premium travel experience for corporate clients."
},
{
"name": "Factory Worker Transport Electronic City",
"description": "Factory Worker Transport Electronic City provides large-scale industrial workforce commuting with punctual shift-based routing, multi-route coverage, safety-first driving, and dependable vehicle operations. It is ideal for manufacturing units and industries around Electronic City requiring daily worker mobility."
},
{
"name": "Office Cab Electronic City",
"description": "Office Cab Electronic City delivers daily office commute services with structured pickup-drop schedules, verified professional drivers, and flexible routing options. It supports regular office hours, hybrid work schedules, and shift-based requirements for companies across Electronic City."
},
{
"name": "Corporate Shuttle Electronic City",
"description": "Corporate Shuttle Electronic City provides large shuttle vans, AC minibuses, and premium corporate vehicles for mass employee transportation. It ensures efficient workforce mobility with centralized dispatching, route optimization, and strong safety compliance for large corporate campuses in Electronic City."
}
],

"tableData": [
["E City Employee Transportation", "Electronic City IT Park Cab"],
["Staff Shuttle Electronic City", "Company Cab Electronic City"],
["Employee Pickup Drop E City", "Corporate Fleet Electronic City"],
["Business Cab Electronic City", "Monthly Corporate Cab Electronic City"],
["Affordable Cab Electronic City", "Outstation Cab Electronic City"],
["Sedan Cab Electronic City", "SUV Cab Electronic City"],
["Factory Worker Transport Electronic City", "Office Cab Electronic City"],
["Corporate Shuttle Electronic City", ""]
],


  





"whychoose": [
  {
    "WhyChooseheading": "Cab Service in Electronic City Bangalore",
    "WhyChoosedescription": "Pune Corporate Cars India Private Limited offers reliable cab services in Electronic City Bangalore, ensuring smooth and efficient transportation for employees and business executives."
  },
  {
    "WhyChooseheading": "Timely Pickups & Drop-offs",
    "WhyChoosedescription": "We guarantee punctual pickups and drop-offs across Electronic City’s IT parks, corporate offices, and business hubs, helping professionals reach their destinations without delays."
  },
  {
    "WhyChooseheading": "Professional & Experienced Drivers",
    "WhyChoosedescription": "Our trained chauffeurs provide safe, courteous, and disciplined travel, ensuring comfortable and secure commuting for corporate clients."
  },
  {
    "WhyChooseheading": "Well-Maintained Vehicle Fleet",
    "WhyChoosedescription": "Choose from sedans, SUVs, tempo travellers, and buses—all sanitized, serviced, and maintained for safe and comfortable corporate travel."
  },
  {
    "WhyChooseheading": "Customized Corporate Travel Packages",
    "WhyChoosedescription": "We offer flexible cab rental plans tailored to meet the commuting requirements of businesses and employees in Electronic City Bangalore."
  },
  {
    "WhyChooseheading": "24/7 Corporate Travel Support",
    "WhyChoosedescription": "Our team provides round-the-clock assistance for bookings, emergencies, and route adjustments, ensuring uninterrupted corporate travel."
  },
  {
    "WhyChooseheading": "Safe & Hygienic Rides",
    "WhyChoosedescription": "All vehicles are regularly sanitized and equipped with modern safety features, offering secure and comfortable rides for employees and executives."
  },
  {
    "WhyChooseheading": "Efficient Booking & Coordination",
    "WhyChoosedescription": "Corporate travel is managed effortlessly through our streamlined booking process and reliable coordination, making employee transport hassle-free."
  }
]































  }

const faqData = [
  {
    question: 'Do you provide cab services in Electronic City, Bangalore?',
    answer: 'Yes, Pune Corporate Cars India Private Limited offers reliable and professional cab services for companies and employees in Electronic City, Bangalore.',
  },
  {
    question: 'What types of cab services are available in Electronic City?',
    answer: 'We provide employee transportation, corporate pickups and drops, airport transfers, shuttle services, and dedicated fleet solutions for IT parks and companies.',
  },
  {
    question: 'Do you support daily office commute services in Electronic City?',
    answer: 'Yes, we offer daily commute solutions with timely pickups, smart routing, and shift-based transportation for employees working in Electronic City.',
  },
  {
    question: 'How can companies book cab services in Electronic City?',
    answer: 'Companies can book through our website, mobile app, or by contacting our 24×7 corporate support team.',
  },
  {
    question: 'What vehicles are available for corporate cab services?',
    answer: 'We offer hatchbacks, sedans, SUVs, luxury cars, Innova Crysta, and tempo travellers depending on corporate requirements.',
  },
  {
    question: 'Do you offer monthly or annual cab service contracts?',
    answer: 'Yes, we provide flexible monthly, quarterly, and annual cab service contracts with transparent pricing.',
  },
  {
    question: 'Are safety and tracking features included in your cab services?',
    answer: 'All our vehicles are GPS-enabled, sanitized regularly, and driven by professionally trained and verified chauffeurs.',
  },
  {
    question: 'Do you provide multi-shift employee cab services in Electronic City?',
    answer: 'Yes, we manage transportation for all shifts including night, early morning, and rotational shifts.',
  },
  {
    question: 'What payment modes are available for cab services in Electronic City?',
    answer: 'We accept UPI, bank transfers, credit/debit cards, digital wallets, and provide consolidated corporate invoicing.',
  },
];

const testimonials = [
  {
    id: 1,
    name: 'Mr. Arjun Menon',
    feedback: 'Excellent cab service in Electronic City. Punctual, safe, and very well-managed for our daily employee transport needs.',
    rating: 5,
  },
  {
    id: 2,
    name: 'Ms. Pooja Krishnan',
    feedback: 'Reliable corporate cab service with clean vehicles and professional drivers. Perfect for our Electronic City office.',
    rating: 5,
  },
];


































































































  const Images = [
    { place: "/images/keyword/1.jpg", text: "Corporate Cab Services in Pune", link: "corporate-cab-services-in-pune" },
{ place: "/images/keyword/2.jpg", text: "Monthly Cab Services in Pune", link: "monthly-cab-services-in-pune" },
{ place: "/images/keyword/3.jpg", text: "Corporate Car Rental in Pune", link: "corporate-car-rental-in-pune" },
{ place: "/images/keyword/4.jpg", text: "Corporate Car Rentals Services in Pune", link: "corporate-car-rentals-services-in-pune" },
{ place: "/images/keyword/5.jpg", text: "Corporate cab services for Pune Outstation", link: "corporate-cab-services-for-pune-outstation" },
{ place: "/images/keyword/6.jpg", text: "Corporate Cab Service in Kharadi", link: "corporate-cab-service-in-kharadi" },
{ place: "/images/keyword/7.jpg", text: "Corporate Cab Service in Hadapsar", link: "corporate-cab-service-in-hadapsar" },
{ place: "/images/keyword/8.jpg", text: "Corporate Cab Service in Viman Nagar", link: "corporate-cab-service-in-viman-nagar" },
{ place: "/images/keyword/9.jpg", text: "Monthly Pick and Drop Service Pune", link: "monthly-pick-and-drop-service-pune" },
{ place: "/images/keyword/10.jpg", text: "Corporate Cab Services in Hinjewadi", link: "corporate-cab-services-in-hinjewadi" },
{ place: "/images/keyword/11.jpg", text: "Corporate Cab Service in Talegaon MIDC", link: "corporate-cab-service-in-talegaon-midc" },
{ place: "/images/keyword/12.jpg", text: "Corporate Cab Services in Chakan MIDC", link: "corporate-cab-services-in-chakan-midc" },
{ place: "/images/keyword/13.jpg", text: "Corporate Cab Services in Talawade MIDC", link: "corporate-cab-services-in-talawade-midc" },
{ place: "/images/keyword/14.jpg", text: "Cab Service for IT Company in Pune", link: "cab-service-for-it-company-in-pune" },
{ place: "/images/keyword/15.jpg", text: "Corporate Cab Services in Bhosari MIDC", link: "corporate-cab-services-in-bhosari-midc" },
{ place: "/images/keyword/16.jpg", text: "Office Pickup and Drop Service in Pune", link: "office-pickup-and-drop-service-in-pune" },
{ place: "/images/keyword/17.jpg", text: "Corporate Cabs Services in Sanaswadi", link: "corporate-cabs-services-in-sanaswadi" },
{ place: "/images/keyword/18.jpg", text: "Corporate Cab Services in Ranjangaon MIDC", link: "corporate-cab-services-in-ranjangaon-midc" },
{ place: "/images/keyword/19.jpg", text: "Corporate Cab Services in Karegaon MIDC", link: "corporate-cab-services-in-karegaon-midc" },
{ place: "/images/keyword/20.jpg", text: "Corporate Cab Services in Shirwal MIDC", link: "corporate-cab-services-in-shirwal-midc" },
{ place: "/images/keyword/21.jpg", text: "Corporate Cab Services in Shikrapur MIDC", link: "corporate-cab-services-in-shikrapur-midc" },
{ place: "/images/keyword/22.jpg", text: "Cab Service in Jejuri MIDC", link: "cab-service-in-jejuri-midc" },
{ place: "/images/keyword/23.jpg", text: "Best Cab Service for Corporate Employees Pune", link: "best-cab-service-for-corporate-employees-pune" },
{ place: "/images/keyword/24.jpg", text: "Corporate Travel Companies in Pune", link: "corporate-travel-companies-in-pune" },
{ place: "/images/keyword/25.jpg", text: "Innova Crysta Hire for Corporate Events in Pune", link: "innova-crysta-hire-for-corporate-events-in-pune" }
  ];











const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Cab Service in Electronic City Bangalore",
  "image": "https://www.punecorporatecars.com/assets/images/corporate-cab-electronic-city.jpg", // replace with correct image if needed
  "description":
    "Pune Corporate Cars India Private Limited provides professional cab services in Electronic City Bangalore, including employee transportation, IT park staff shuttles, office pickup & drop, corporate fleet solutions, business cabs, monthly corporate cab plans, outstation trips, and executive chauffeur-driven vehicles for companies operating in Electronic City.",
  "brand": {
    "@type": "Brand",
    "name": "Pune Corporate Cars India Private Limited"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "ratingValue": "4.9",
    "ratingCount": "5800",
    "bestRating": "5",
    "worstRating": "1"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "2400",
    "availability": "https://schema.org/InStock",
    "url": "https://www.punecorporatecars.com/cab-service-electronic-city-bangalore"
  }
};






  return (
    <div>
<Helmet>
  <title>Cab Service in Electronic City Bangalore | Employee & Corporate Transport</title>

  <meta
    name="description"
    content="Reliable cab services in Electronic City Bangalore including employee transportation, IT park staff shuttles, office pickup & drop, business and corporate cabs, monthly cab plans, outstation trips, and corporate fleet solutions for companies in Electronic City."
  />

  <meta
    name="keywords"
    content="E City Employee Transportation, Electronic City IT Park Cab, Staff Shuttle Electronic City, Company Cab Electronic City, Employee Pickup Drop E City, Corporate Fleet Electronic City, Business Cab Electronic City, Monthly Corporate Cab Electronic City, Affordable Cab Electronic City, Outstation Cab Electronic City, Sedan Cab Electronic City, SUV Cab Electronic City, Factory Worker Transport Electronic City, Office Cab Electronic City, Corporate Shuttle Electronic City"
  />

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>

      <section
        className="breadcrumb-section"
        style={{ backgroundImage: "url(/images/background/inner-banner-bg.jpg)" }}
      >
        <div className="container">
          <div className="banner-content">
            <h1>{cardData.keyword}</h1>
          </div>
        </div>
      </section>













      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/115.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                <p className="sectionLead">{cardData.top}</p>

                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>
              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    <div className="service-icon">
                      🚖
                    </div>
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Pune Corporate Company</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Pune Corporate Company </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+919822136667" className="pc-call">+91 9822136667</a>
                      <a href="tel:+917350959600" className="pc-call">+91 7350959600</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/919822136667"
                        target="_blank" rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp me-1"></i> WhatsApp
                      </a>
                      <a href="tel:+919822136667" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:sanjay.nalawade@punecorporatecars.com" className="pc-email">
                      sanjay.nalawade@punecorporatecars.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-house-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                     <strong>Pune Corporate Company</strong><br />
                      Gate No 124/2/1 Plot No 86 Vishva Vilas City
Lane No 08 Khandave Nagar Nagar Road Lohgaon
Haveli, Pune 412207 Maharashtra, India
                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Cabserviceinelectroniccitybanglore;